/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Clear, Refresh, Search, Grading } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridRowSelectionModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import AutoComplete from "@/components/hookForms/autoComplete";
import AutoCompleteMulti from "@/components/hookForms/autoCompleteMult";
import { Container } from "@/theme/globalStyles";
import DataTable from "../../../components/dataTable";
import Datapicker from "@/components/hookForms/datePicker";
import IGenericResult from "@/interfaces/IGenericResult";
import messages from "@/utils/messages";
import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import DialogInfo from "./modal/dialogInfo";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { parse } from "date-fns";

const HistoricoProcessamento: React.FC = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();

    useEffect(() => {
        setTitlePage("Rebalance - Histórico de processamento");
    }, [setTitlePage]);

    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [statusDataOptions, setStatusDataOptions] = useState<any[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
          field: "",
          sort: "" as GridSortDirection
        }
      ]);

    const validationSchema = yup.object().shape({
        cicloFaturamento: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            cicloFaturamento: null || new Date(),
            concessionariaID: "",
            usinasIds: "",
            status: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operação",
                field: "operations",
                type: "actions",
                width: 180,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Detalhar">
                                <Grading />
                            </Tooltip>
                        }
                        label="Detalhar"
                        onClick={() =>
                            history.push("/rebalance/detalharHistorico", {
                                rebalanceUsinaID: params.row.rebalanceUsinaID,
                                usinaID: params.row.usinaID,
                                status: params.row.status,
                                filterOld: filters,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Tornar atual">
                                <Refresh />
                            </Tooltip>
                        }
                        label="Tornar atual"
                        onClick={() => {
                            reload(params.row.usinaID, params.row.versao);
                        }}
                        disabled={
                            (params.row.status !== "Aberto" && params.row.status !== "Processado") ||
                            !isCicloAtual(params.row.cicloFaturamento)
                        }
                    />,
                ],
            },
        ],
        [filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebalanceUsinaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                width: 120,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 180,
            },
            {
                headerName: "Concessionária",
                field: "nomeConcessionaria",
                type: "string",
                width: 140,
            },
            {
                headerName: "Versão",
                field: "versao",
                type: "number",
                width: 120,
            },
            {
                headerName: "Status",
                field: "status",
                type: "string",
                width: 200,
            },
            {
                headerName: "Usuário",
                field: "nomeUsuario",
                type: "string",
                width: 180,
            },

            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setConcessionariaData();
        setDataStatus();
    }, []);

    useEffect(() => {
        if (props && props.location && props.location.state) {
            setFilters(props.location.state);
            const newValues = {
                ...props.location.state,
                usinasIds: Array.isArray(props.location.state.usinasIds) ? props.location.state.usinasIds.join(',') : props.location.state.usinasIds 
            }
            
            getUsinaData({ concessionariaID: props.location.state.concessionariaID });
            getAllWithFilters(newValues);
            reset({ ...props.location.state });
        }
    }, [props]);

    const setDataStatus = () => {
        serviceRebalanceUsina
            .getStatusRebalance()
            .then((result) => {
                if (result) {
                    setStatusDataOptions(result?.data);
                }
            })
            .catch(() => {
                setStatusDataOptions([]);
            });
    };

    const getUsinaData = async (values: any) => {
        if (values.concessionariaID) {
            serviceRebalanceUsina
                .getUsinasByConcessionaria(values)
                .then((result) => {
                    if (result) {
                        setUsinaDataOptions(result?.data);
                    }
                })
                .catch(() => {
                    setUsinaDataOptions([]);
                });
        }
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    function reload(id: number, versao: number) {
        const newValues = {
            usinaID: id,
            versaoAnterior: versao,
        };

        serviceRebalanceUsina.setCurrent(newValues).then(() => {
            toast.success("Sucesso na definição como versão atual para o item selecionado.");
            getAllWithFilters(filters);
        });
    }

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        const newValues = {
            ...filters,
            cicloFaturamento: filters?.cicloFaturamento
                ? format(filters?.cicloFaturamento, "MM/yyyy")
                : format(new Date(), "MM/yyyy"),
        };

        serviceRebalanceUsina
            .getHistorico({ ...newValues, take: pageSize, currentPage: page + 1, 
                sortExpression: sortModel[0]?.field ?? "", sortDirection: sortModel[0]?.sort ?? ""})
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newValues = {
            ...values,
            usinasIds: values.usinasIds ? values.usinasIds.join(",") : "",
        };

        setFilters(newValues);
        getAllWithFilters(newValues);
    };

    useEffect(() => {
        if (dataMessages.length > 0) setInfoModal(true);
    }, [dataMessages]);

    const onClear = () => {
        setFilters(null);
        getAllWithFilters(null);
        const el = document.getElementsByClassName("MuiAutocomplete-clearIndicator")[1] as HTMLElement;
        if (el) {
            el.click();
        }
        reset({
            cicloFaturamento: null || new Date(),
            concessionariaID: "",
            status: "",
            usinasIds: "",
        });
    };

    function isCicloAtual(cicloFaturamento): boolean {
        let ciclo = parse('01/' + cicloFaturamento, "dd/MM/yyyy", new Date());
        let now = new Date();
        return format(ciclo, "MM") === format(now, "MM") && format(ciclo, "yyyy") === format(now, "yyyy");
    }

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <Datapicker
                                                name="cicloFaturamento"
                                                label="Referência"
                                                control={control}
                                                error={errors}
                                                format="MM/yyyy"
                                                view={["month", "year"]}
                                                noDateForward
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="concessionariaID"
                                                label="Concessionária"
                                                options={concessionariaDataOptions}
                                                control={control}
                                                error={errors}
                                                onChange={(idConcessionaria) => {
                                                    if (idConcessionaria) {
                                                        getUsinaData({ concessionariaID: idConcessionaria });
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoCompleteMulti
                                                name="usinasIds[]"
                                                label="Usinas"
                                                options={usinaDataOptions}
                                                control={control}
                                                error={errors}
                                                limitTags={1}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="status"
                                                label="Status"
                                                options={statusDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceUsinaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            initialState={{ pinnedColumns: { right: ["Operação", "operations"] } }}
                            // checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>
            </Card>

            {infoModal && (
                <DialogInfo
                    data={dataMessages}
                    onClose={() => {
                        setInfoModal(false);
                        setDataMessages([]);
                    }}
                />
            )}
        </Container>
    );
};

export default HistoricoProcessamento;
